import config from 'SRC/config/config.json'

export const adFiltersLabels = config.filters.adFiltersLabels
